import React, {memo} from 'react'
import cx from 'classnames'

/* Components */
import VoltranFragment from '../../../../components/VoltranFragment/VoltranFragment'

/* Config */
import appConfig from '../../../../appConfig'

/* Constants */
import {DESKTOP_COMPONENTS, DESKTOP_COMPONENTS_OPTIONS} from '../../../../modules/voltran/voltranConstants'
import {TAB_EVENT_LISTENER, TAB_IDS} from '../../../../modules/product/productDesktopConstants'
import {FEATURE_TOGGLE_NAMES} from '../../../../modules/feature-toggle/featureToggleConstants'
import {DAVINCI_EVENT_NAMES} from '../../../../modules/analytics/davinci/davinciConstants'

/* Actions */
import {actionCreators as productActionsCreators} from '../../../../redux/actions/productActions'

/* Utils */
import {setAskToSellerButtonAttributes} from '../../../../modules/product/productDesktopUtils'
import {yieldToMain} from '../../../../utils/performance'

/* Styles */
import s from './buybox-seller.scss'

const BuyboxSeller = memo(({
  dispatch,
  product,
  pageFeatureToggleMap,
  merchantName,
  merchantUrl,
  merchant,
  fragmentsMap,
  categoryId,
  categoryUrlKeyword,
  categories,
  merchantId,
  listingId,
  price,
  productId,
  sku
}) => {
  if (pageFeatureToggleMap?.get(FEATURE_TOGGLE_NAMES.ASK_TO_MERCHANT_ENABLED) && fragmentsMap?.get(DESKTOP_COMPONENTS_OPTIONS[DESKTOP_COMPONENTS.ASK_TO_SELLER]?.id?.toString())) {
    setTimeout(() => {
      setAskToSellerButtonAttributes(product)
    })
  }

  const askToSellerClick = async() => {
    let findTabIndex = window?.tabListNames?.findIndex?.(item => item.id === TAB_IDS.QUESTION_ANSWER);
    await yieldToMain()
    if (!window?.tabListNames?.[findTabIndex]?.load) {
      window?.HbEventBus?.emit(TAB_EVENT_LISTENER, {
        id: TAB_IDS.QUESTION_ANSWER,
        index: findTabIndex
      })
    } else {
      dispatch(productActionsCreators.setDesktopTabs.trigger(findTabIndex))
      document.getElementById('tab')?.scrollIntoView({behavior: 'smooth'})
    }
  }

  const handleMerchantClick = () => {
    window?.hepsiBus?.track(DAVINCI_EVENT_NAMES.GO_TO_SELLER_CLICK, {
      category: {
        id: categoryId,
        name: categoryUrlKeyword,
      },
      category_hierarchy: categories.map((category) => ({id: category.categoryId, name: category.categoryName})),
      merchant: {
        id: merchantId,
        name: merchantName,
      },
      products: [
        {
          listingId,
          position: 1,
          price: `${price}`,
          product_id: productId,
          product_status: '',
          shipping_type: '',
          sku,
        }
      ]
    })
  }

  return (
    <div className={s.root} data-test-id={'buyBox-seller'}>
      <div className={s.merchantContainer}>
        <span className={s.merchantText}>{'Satıcı: '}</span>
        {
          merchantUrl ?
            <a
              className={s.merchantUrl} href={`${appConfig.baseUrl}/magaza/${merchantUrl}`} title={merchantName}
              onClick={handleMerchantClick}>
              <span className={s.merchantName}>{merchantName}</span>
            </a> :
            <div className={s.merchantUrl} onClick={handleMerchantClick}>
              <span className={cx(s.merchantName, s.cursorDisabled)}>{merchantName}</span>
            </div>
        }
        {
          <div className={s.tooltip}>
            {
              Boolean(merchant?.labelName) &&
              <div
                className={s.label} data-test-id={'merchant-label'}>
                <i className={s.icon}/>
                <span className={s.labelName}>{merchant?.labelName}</span>
              </div>
            }
            {
              merchant?.lifetimeRating > 0 &&
              <div className={s.merchantInfo}>
                {
                  merchant?.lifetimeRating > 0 &&
                  <span
                    className={cx(s.rating, s[`rating${Math.floor(merchant?.lifetimeRating)}`])}
                    data-test-id={'merchant-rating'}>
                    {
                      parseFloat(merchant?.lifetimeRating).toFixed(1).
                        replace('.', ',')
                    }
                  </span>
                }
              </div>
            }
            {
              (Boolean(merchant?.labelName) || merchant?.lifetimeRating > 0) &&
              <div className={s.tooltipText}>
                {
                  Boolean(merchant?.labelName) &&
                  <div className={cx(s.trustLabelArea, {[s.dividers]: merchant?.lifetimeRating > 0})}>
                    <div className={s.trustLabelHeader}>
                      <i/>
                      <span>{merchant?.labelName}</span>
                    </div>
                    <span className={s.trustLabelText}>
                      {'Türkiye veya Dünya’da yüksek bilinirliğe sahip markalara ait satıcılara onaylanmış satıcı rozeti verilir.'}
                    </span>
                  </div>
                }
                {
                  merchant?.lifetimeRating > 0 &&
                  <div className={s.ratingArea}>
                    <div className={s.ratingAreaHeader}>
                      {
                        merchant?.lifetimeRating > 0 &&
                        <span
                          className={cx(s.rating, s[`rating${Math.floor(merchant?.lifetimeRating)}`])}
                          data-test-id={'merchant-rating'}>
                          {
                            parseFloat(merchant?.lifetimeRating).toFixed(1).
                              replace('.', ',')
                          }
                        </span>
                      }
                      <span className={s.ratingTitle}>Satıcı puanı</span>
                    </div>
                    <span className={s.ratingText}>
                      {'Satıcı puanı, müşteri geri bildirimleri ve satıcının sipariş sürecindeki performansı dikkate alınarak hesaplanmaktadır.'}
                    </span>
                  </div>
                }
              </div>
            }
          </div>
        }
      </div>
      {
        fragmentsMap?.get(DESKTOP_COMPONENTS_OPTIONS[DESKTOP_COMPONENTS.FOLLOW_AND_COLLECT]?.id?.toString()) &&
        <div className={s.followButton}>
          <VoltranFragment
            fragmentInfo={fragmentsMap?.get(DESKTOP_COMPONENTS_OPTIONS[DESKTOP_COMPONENTS.FOLLOW_AND_COLLECT]?.id?.toString())}
            options={DESKTOP_COMPONENTS_OPTIONS[DESKTOP_COMPONENTS.FOLLOW_AND_COLLECT]}
            renderMethodClientSide={process.env.BROWSER}/>
        </div>
      }
      {
        fragmentsMap?.get(DESKTOP_COMPONENTS_OPTIONS[DESKTOP_COMPONENTS.ASK_TO_SELLER]?.id?.toString()) &&
        <div className={s.askToSellerButton} onClick={askToSellerClick}>
          <VoltranFragment
            fragmentInfo={fragmentsMap?.get(DESKTOP_COMPONENTS_OPTIONS[DESKTOP_COMPONENTS.ASK_TO_SELLER]?.id?.toString())}
            options={DESKTOP_COMPONENTS_OPTIONS[DESKTOP_COMPONENTS.ASK_TO_SELLER]}
            renderMethodClientSide={process.env.BROWSER}
            scriptProps={{type: 'module'}}/>
        </div>
      }
    </div>
  )
})

export default BuyboxSeller
